import {POST} from "@/services/gateway";

const listInitialBackupStats = (filter) => {
  return POST('common/initial-backup-stats', filter)
}

export {
  listInitialBackupStats
}
